import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { VehicleType } from "@app/enum/VehicleType.enum";
import { IKeyValuePair } from "@app/interfaces/IKeyValuePair";
import { ContextualSpeedingThreshold } from "@app/main/components/resourceManagement/contextual-speeding-settings-manager/models/contextual-speeding-threshold";
import { lastValueFrom } from "rxjs";
import { TranslationService } from "./translation.service";
import { VehicleService } from "./vehicle.service";

@Injectable({
    providedIn: 'root'
})
export class ContextualSpeedingThresholdService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly vehicleService: VehicleService,
        private readonly translationService: TranslationService
    ) { }

    async getContextualSpeedingThresholds(): Promise<ContextualSpeedingThreshold[]> {
        return await lastValueFrom(this.httpClient.get<ContextualSpeedingThreshold[]>(`/api/speeding/threshold`));
    }

    async addContextualSpeedingThreshold(threshold: ContextualSpeedingThreshold): Promise<ContextualSpeedingThreshold> {
        return await lastValueFrom(this.httpClient.post<ContextualSpeedingThreshold>(`/api/speeding/threshold`, threshold));
    }

    async updateContextualSpeedingThreshold(threshold: ContextualSpeedingThreshold): Promise<ContextualSpeedingThreshold> {
        return await lastValueFrom(this.httpClient.post<ContextualSpeedingThreshold>(`/api/speeding/threshold/${threshold.Id}`, threshold));
    }

    async deleteContextualSpeedingOverride(thresholdId: number): Promise<any> {
        return await lastValueFrom(this.httpClient.delete(`/api/speeding/threshold/${thresholdId}`));
    }

    getAdjustedVehicleTypes(): IKeyValuePair<VehicleType>[] {
        const vehicleTypes = this.vehicleService
            .getVehicleTypes()
            .filter(x => x.value !== VehicleType.None);

        return vehicleTypes;
    }
}
